import React, { memo } from 'react'
import Banner from '@/components/Banner'
import ProductIntro from './components/ProductIntro'
import styles from './style.module.scss'

function Product() {
  const bannerList = [
    {
      tabTitle: '龙之谷手游',
      type: 'image',
      url: 'https://tc-cdn.123u.com/official-website/product/dn-banner.png',
      mobileUrl:
        'https://tc-cdn.123u.com/official-website/product/dn-banner-small.png',
      content: (
        <div className={`${styles.Description}`}>
          <div className={styles.Title}>無差別，真競技</div>
          <div className={styles.SubTitle}>
            龍之谷是一款3D無鎖定動作手游，具有酣暢自由的戰鬥體驗，原汁原味的經典形象，刻骨銘心的淚點劇情等特點。龍之谷手游力求100%還原端遊特色，將精彩絕倫的戰鬥於掌中呈現，讓玩家的指尖踏上非同凡響的阿爾特里亞之旅。
          </div>
          <div
            onClick={() => window.open('https://dn.qq.com/index.shtml')}
            className={styles.DetailBtn}
          >
            查看详情
          </div>
        </div>
      ),
    },
    {
      tabTitle: '英雄杀小游戏',
      type: 'image',
      url: 'https://tc-cdn.123u.com/official-website/product/yxs.png',
      mobileUrl:
        'https://tc-cdn.123u.com/official-website/mobile/product/yxs.png',
      content: (
        <div className={`${styles.Description}`}>
          <div className={styles.Title}>策略卡牌，公平競技</div>
          <div className={styles.SubTitle}>
            英雄殺小遊戲是一款結合了歷史人物特色的競技卡牌遊戲。在英雄殺小遊戲裡，玩家通過選擇不同的角色，根據不同角色的技能組合搭配隨機拿到的手牌進行戰鬥，並根據場上的狀況及時變更對戰策略，才能贏得最終的勝利。
          </div>
          {/* <div onClick={() => window.open('https://yxsm.qq.com/')} className={styles.DetailBtn}>查看详情</div> */}
        </div>
      ),
    },
    {
      tabTitle: '街机三国',
      type: 'image',
      url: 'https://tc-cdn.123u.com/official-website/product/jjsg_v2.jpg',
      mobileUrl:
        'https://tc-cdn.123u.com/official-website/mobile/product/jjsg.png',
      content: (
        <div className={`${styles.Description}`}>
          <div className={styles.Title}>喚醒街機格鬥的激情</div>
          <div className={styles.SubTitle}>
            遊戲中以《三國志》為時代背景，玩家扮演的角色穿越到三國時代，成為天選之子，還原了原著中的人物派系和歷史戰場，為玩家提供7個職業，並有個人爭霸，軍團爭霸，三國爭霸等多項賽事活動。
          </div>
          <div
            onClick={() => window.open('http://sg.huanle.com/')}
            className={styles.DetailBtn}
          >
            查看詳情
          </div>
        </div>
      ),
    },
    {
      tabTitle: '美食大战老鼠',
      type: 'image',
      url: 'https://tc-cdn.123u.com/official-website/product/ms.png',
      mobileUrl:
        'https://tc-cdn.123u.com/official-website/mobile/product/ms.png',
      content: (
        <div className={`${styles.Description}`}>
          <div className={styles.Title}>十年易逝，經典不老</div>
          <div className={styles.SubTitle}>
            《美食大戰老鼠》是一款極富策略性的網頁休閒遊戲。貪婪的老鼠結隊前來掠奪美食，唯一的防禦方式就是培育美食進行反擊。遊戲集成了角色成長、即時戰略、塔防戰和卡片收集等要素，樂趣十足。
          </div>
          <div
            onClick={() => window.open('http://my.4399.com/yxmsdzls/')}
            className={styles.DetailBtn}
          >
            查看詳情
          </div>
        </div>
      ),
    },
  ]

  const productLists = [
    {
      img: 'https://tc-cdn.123u.com/official-website/product/dn-ck.png',
      title: '龍之谷手游',
      subTitle: '無差別，真競技',
      url: 'https://dn.qq.com/index.shtml',
    },
    {
      img: 'https://tc-cdn.123u.com/official-website/product/yxs-ck.png',
      title: '英雄殺',
      coverImg:
        'https://tc-cdn.123u.com/official-website/product/yxs-qr-10-03.png',
      subTitle: '策略卡牌，公平競技',
      url: 'https://yxsm.qq.com/',
    },
    {
      img: 'https://tc-cdn.123u.com/official-website/product/jjsg-ck_v2.png',
      title: '街機三國',
      subTitle: '喚醒街機格鬥的激情',
      url: 'http://sg.huanle.com/',
    },
    {
      img: 'https://tc-cdn.123u.com/official-website/product/ms-ck.png',
      title: '美食大戰老鼠',
      subTitle: '十年易逝，經典不老',
      url: 'http://my.4399.com/yxmsdzls/',
    },
    {
      img: 'https://tc-cdn.123u.com/official-website/product/more-ck.png',
      title: '即將上線',
      subTitle: '更多精彩遊戲，敬請期待',
      url: '',
      closed: true,
    },
  ]

  return (
    <>
      <Banner bannerList={bannerList} autoplay showBottomTabs loop showArrow />
      <div className={styles.ImageWrap}>
        <img src="https://tc-cdn.123u.com/official-website/product/ourgames.png" />
        <div className={styles.OurGame}>
          <div className={styles.Title}>OUR GAMES</div>
          <div className={styles.SubTitle}>讓更多人發現人生的美好</div>
        </div>
      </div>
      <div id="product-card">
        <ProductIntro productLists={productLists} />
      </div>
    </>
  )
}

export default memo(Product)
